module.exports = __webpack_public_path__ + "img/II-44.2.e007b130.svg";